import { Pack, PurchaseWallpaperPack } from 'types';
import { request } from 'utils';

export const savePack = (pack: Pack) => {
  const form = new FormData();
  form.append('properties', JSON.stringify(pack.properties));

  pack.items.forEach((item) => {
    form.append('files', item.fileToUpload as any, item.id);
  });

  form.append(
    'items',
    JSON.stringify(pack.items.map(item => ({
      id: item.id,
      properties: item.properties,
      width: item.width,
      height: item.height,
      order: item.order,
      startIndex: item.startIndex,
      disabledIndices: item.disabledIndices,
    }))));

  const publishAt = encodeURIComponent(JSON.stringify(pack.publishAt));

  return !!pack.id ?
    request.put(`/mu/packs/${pack.id}?publishAt=${publishAt}`, form) :
    request.post(`/mu/packs?publishAt=${publishAt}`, form);
};

export const getPackList = (offset: number = 0, limit: number = 10) =>
  request.get(`/mu/packs/admin?offset=${offset}&limit=${limit}`);

export const deletePack = (id: string) => request.delete(`/mu/packs/${id}`);

export const savePurchaseWallpaperPack = (pack: PurchaseWallpaperPack) => {
  const form = new FormData();

  pack.items.forEach((item) => {
    form.append('files', item.fileToUpload as any, item.id);
  });

  form.append(
    'items',
    JSON.stringify(pack.items.map(item => ({
      id: item.id,
      order: item.order,
    }))));

  return !!pack.id ?
    request.put(`/mu/purchase-wallpapers-packs/${pack.id}`, form) :
    request.post('/mu/purchase-wallpapers-packs', form);
};

export const getPurchaseWallpaperPackList = (offset: number = 0, limit: number = 10) =>
  request.get(`/mu/purchase-wallpapers-packs?offset=${offset}&limit=${limit}`);

export const deletePurchaseWallpaperPack = (id: string) =>
  request.delete(`/mu/purchase-wallpapers-packs/${id}`);

export const setPurchaseWallpaperPackActive = (id: string) =>
  request.post(`/mu/purchase-wallpapers-packs/active/${id}`);
